import {Injectable} from '@angular/core';
import {ApiResponse, ApiService} from './api/api.service';
import {Project} from '../classes/project';
import {map, tap} from 'rxjs/operators';
import {EntityImage} from '../classes/entityimage';

@Injectable({
    providedIn: 'root'
})
export class ProjectService {

    constructor(private apiService: ApiService) {
    }

    list(searchText?: string) {
        return this.apiService.getCall$<Project[]>(`projects`, {searchText: searchText ?? ''});
    }

    get(id: number, onlyProject?: boolean) {
        return this.apiService.getCall$<Project>(`projects/${id}`, {onlyProject}).pipe(tap(project => {
            if(!project.data.workorders){
                project.data.workorders = [];
                project.data.drawings = [];
            }
        }));
    }

    getImagesForProject(id: number) {
        return this.apiService.getCall$<EntityImage[] | { h: number; d: number; r: string; l: string; }[]>(`projects/${id}/images`).pipe(map(imageResponse => {
            return imageResponse as ApiResponse<EntityImage[]>;
        }));
    }

}
